import { useStores } from '../../../../app/root/domain/stores/useStores';

export function useMyBookingsStore() {
	const { myBookingsStore } = useStores();

	return myBookingsStore;
}
